import getCookie from "./getCookie";
export default function checkCookie(cname) {
    const cookie = getCookie(cname);
    if (cookie !== "") {
        return true;
    }
    return false;
}
